import type { NoteMark } from '@feral/shared/client'
import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api.js'
import { useSession } from '../../lib/session.js'

export const NOTES_KEY = ['notes'] as const
export const noteKey = (id: string) => ['note', id] as const

/** Who may see the way in: Plus members, and Trusted members (the lock and the way to Plus). */
export function useNotesOffer(): 'open' | 'locked' | null {
  const { me } = useSession()
  if (me?.plus) return 'open'
  return me?.state === 'trusted' ? 'locked' : null
}

/** Under NOTES_KEY, so every note save refreshes it too. */
export const MARKS_KEY = ['notes', 'marks'] as const
/** Your tags for the tag box to offer (decision 180), under NOTES_KEY for the same reason. */
export const TAGS_KEY = ['notes', 'tags'] as const

/** Your name, rating, vibes and warnings for one person (decision 51); null without Plus or a note. */
export function useMark(id: string | null | undefined): NoteMark | null {
  const plus = useSession((s) => !!s.me?.plus)
  const q = useQuery({ queryKey: MARKS_KEY, queryFn: api.noteMarks, enabled: plus, staleTime: 60_000 })
  return (id && q.data?.[id]) || null
}
